export default __webpack_public_path__ + "static/media/empty-blue-stroke.1ca19c77.svg";